import { render } from "./expertDetail.vue?vue&type=template&id=590cfc81&scoped=true"
import script from "./expertDetail.vue?vue&type=script&lang=js"
export * from "./expertDetail.vue?vue&type=script&lang=js"

import "./expertDetail.vue?vue&type=style&index=0&id=590cfc81&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590cfc81"]])

export default __exports__